import PropTypes from 'prop-types';

/* eslint-disable max-len */

const NewsIcon = ({
  dataTestId = 'newsIcon',
  viewBox = '0 0 30 30',
  height = '30px',
  width = '30px',
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    data-testid={dataTestId}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23 5H7V25H23V5Z" stroke={fill} strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M10.2 9H19.8" stroke={fill} strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M10.2 12H19.8" stroke={fill} strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M10.2 15H19.8" stroke={fill} strokeWidth="1.5" strokeMiterlimit="10" />
    <path d="M10.2 17.999H16.6" stroke={fill} strokeWidth="1.5" strokeMiterlimit="10" />
  </svg>
);
NewsIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  viewBox: PropTypes.string,
};
export default NewsIcon;
